import { render, staticRenderFns } from "./Barrage.vue?vue&type=template&id=2d29a90a&scoped=true&"
import script from "./Barrage.vue?vue&type=script&lang=js&"
export * from "./Barrage.vue?vue&type=script&lang=js&"
import style0 from "./Barrage.vue?vue&type=style&index=0&id=2d29a90a&prod&lang=scss&"
import style1 from "./Barrage.vue?vue&type=style&index=1&id=2d29a90a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d29a90a",
  null
  
)

export default component.exports